import { render, staticRenderFns } from "./newseltos-single-video.vue?vue&type=template&id=decd251a&scoped=true"
import script from "./newseltos-single-video.vue?vue&type=script&lang=js"
export * from "./newseltos-single-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decd251a",
  null
  
)

export default component.exports